import React from "react";

// region Hooks
import { useMsal } from "@azure/msal-react";
// endregion Hooks
// region External libraries
import { uuidv4 } from "@libraries/uuid";
import { atom } from "jotai";
// endregion External libraries
// region Languages
import { UserRightsMessages } from "@languages/interfaces/userRightsMessages";
// endregion Languages
// region Organisms
import PageTabs, { createNewTabsAtom, PageTabProps, useTabsAtom } from "@organisms/PageTabs";
import UserRightsDashboard from "@organisms/UserRightsDashboard";
// endregion Organisms
import * as Styled from "./styles";

/** Enums */
/** Tab panel index based on array position */
enum ETabPanelIndexes {
  UserRightsDashboard = 0
}

const initialTabs: PageTabProps[] = [
  {
    id: uuidv4(),
    tab: {
      title: UserRightsMessages.rightsControl,
      caption: UserRightsMessages.roleDashboardTabCaption,
      fixed: true
    },
    tabPanel: <UserRightsDashboard tabPanelIndex={ETabPanelIndexes.UserRightsDashboard} />
  }
];

export const userRightsTabsAtom = createNewTabsAtom(initialTabs);
export const selectedTabAtom = atom<number>(0);

const UsersRights: React.FC = () => {
  const { pageTabs, setPageTabs, selectedTab, setSelectedTab } = useTabsAtom(userRightsTabsAtom, selectedTabAtom);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let accessGranted = false;

  if (activeAccount?.idTokenClaims?.["extension_Admin"]) {
    accessGranted = activeAccount?.idTokenClaims?.["extension_Admin"] as boolean;
  }

  return (
    <Styled.Container>
      <PageTabs
        content={pageTabs}
        setContent={setPageTabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
    </Styled.Container>
  );
};

export default UsersRights;
